async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}

export async function convertAudioBlobToMp3(
  inputBlob: Blob,
  options: { bitRate?: number; mono?: boolean } = {},
) {
  const {
    bitRate = 128, // kbps
    mono = true, // set false if you want stereo
  } = options;

  // 1. Decode input with Web Audio API
  const arrayBuffer = await blobToArrayBuffer(inputBlob);
  const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer as ArrayBuffer);

  const numChannels = mono ? 1 : audioBuffer.numberOfChannels;
  const sampleRate = audioBuffer.sampleRate;

  // 2. Get PCM samples (mono or stereo)
  let samples;
  if (numChannels === 1) {
    samples = audioBuffer.getChannelData(0);
  } else {
    const left = audioBuffer.getChannelData(0);
    const right = audioBuffer.getChannelData(1);
    const length = left.length + right.length;
    samples = new Float32Array(length);
    let idx = 0;
    for (let i = 0; i < left.length; i++) {
      samples[idx++] = left[i];
      samples[idx++] = right[i];
    }
  }

  // 3. Encode with lamejs
  const mp3encoder = new lamejs.Mp3Encoder(numChannels, sampleRate, bitRate);
  const blockSize = 1152;
  const mp3Chunks = [];

  for (let i = 0; i < samples.length; i += blockSize * numChannels) {
    const chunk = samples.subarray(i, i + blockSize * numChannels);

    // float32 [-1,1] -> int16
    const buf = new Int16Array(chunk.length);
    for (let j = 0; j < chunk.length; j++) {
      let s = Math.max(-1, Math.min(1, chunk[j]));
      buf[j] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }

    const mp3buf = mp3encoder.encodeBuffer(buf);
    if (mp3buf.length > 0) mp3Chunks.push(mp3buf);
  }

  const end = mp3encoder.flush();
  if (end.length > 0) mp3Chunks.push(end);

  // 4. Result: MP3 Blob
  return new Blob(mp3Chunks, { type: 'audio/mpeg' });
}
